<template>
  <div class="loan">
    <div style="position: fixed; top: 50%; left: 50%; z-index: 999;">
    
      
    </div>
    <div class="mb-3" v-if="processingError">
      <va-notification color="danger" closeable>       
        An error occurred! Please Try again later.
      </va-notification>
    </div>
  	<div class="row">
      <div class="flex s12 md9">
      	 <va-card :title="$t('loans.LoansMoreDetails')">
          <template slot="actions">           
	            <va-button icon="fa fa-close"
               @click="EditLoanspage()"
               v-if="showedit"
               >Edit Loan
              </va-button>	           
	        </template>
          <template slot="actions">           
	            <va-button icon="fa fa-close"
               @click="guarantors()"
               v-if="showaddG"
               >Add Guarantors
              </va-button>	           
	        </template>
      	 	<template slot="actions">           
	            <va-button icon="fa fa-close" @click="$router.go(-1)">Cancel</va-button>	           
	        </template>
          
          <va-input
          :label="$t('Loan Type')"
              type="text"
              v-model="this.formdata.loanT"
              :readonly = "true" 
             
        />
        <va-input
          :label="$t('Applied Amount')"
              type="number"
              v-model="this.formdata.appliedamount"
            :readonly = "true" 
             
        />
        <va-input
          :label="$t('Total Guaranteed Amount')"
              type="number"
              v-model="this.formdata.AmountGuarantee" 
              :readonly = "true" 
        />
          <va-data-table
      :fields="mode ? detailedFields : fields"
      :data="filteredData"
      :loading="loading"
      hoverable
    >

      <template slot="icon">
        <va-icon name="fa fa-list" color="secondary" />
      </template>
      <template v-slot:guarantor_full_name="props">
        {{ props.rowData.guarantor_full_name }}
      </template>
      <template v-slot:phone_number="props">
        {{ props.rowData.phone_number  }}

      </template>
 
      <template v-slot:guaranteed_amount="props">
        {{ props.rowData.guaranteed_amount | Currency  }}
      </template>
      <template v-slot:guarantor_status="props">

        <div v-if="props.rowData.guarantor_status==='PENDING' "> 
       <button   style="background-color: blue; color: whitesmoke; border: none; border-radius: 10px; padding: 10px; min-height: 20px; min-width: 110px;">
        {{ props.rowData.guarantor_status}}
         </button> 
         <div v-if="showdel"></div>
        </div>
        <div v-if="props.rowData.guarantor_status==='APPROVED' ">
          
       <button style="background-color: green; color: whitesmoke; border: none; border-radius: 10px; padding: 10px; min-height: 20px; min-width: 110px;">
        {{ props.rowData.guarantor_status}}</button>
        
      </div>

        <div v-if="props.rowData.guarantor_status==='REJECTED'"> 
       <button style="background-color: red; color: whitesmoke; border: none; border-radius: 10px; padding: 10px; min-height: 20px; min-width: 110px;">
        {{ props.rowData.guarantor_status}} 
      </button> </div>
      </template>
      <template  v-slot:details="props">
        <button  v-if="props.rowData.guarantor_status ==='PENDING'" style="background-color: red; color: whitesmoke; border: none; border-radius: 10px; padding: 10px; min-height: 20px; min-width: 110px;" @click="Deleteguaranter(props.rowData.loan_number, props.rowData.phone_number,props.rowData.id_number)">
                  {{ $t('Delete') }}
                 
                </button>  
      </template>
    </va-data-table>
    <va-modal
      v-model="showConfirmModal"
      position="top"
      size = "medium"
      :title=" $t('Request Guarantorship')"
      cancelClass="none"      
      :okText=" $t('Add') "  
      :cancelText=" $t('modal.cancel')"      
      noOutsideDismiss
      noEscDismiss
      @ok = "FinalPost"
    >
    <form @submit.prevent="onsubmit">

<va-input
:label="$t('ID Number')"
type="number"
v-model="formdata.mobilenumber"
:error="!!mobilenumber.length"
:error-messages="mobilenumberErrors"
@input="loaddetais"

/>

<va-input v-if="showName"
:label="$t('name')"
:readonly = "true"           
type="text"
v-model="this.formdata.name"
/>
<va-input
:label="$t('Request Amount')"
type="number"
v-model="formdata.amount"
:error="!!amount.length"
:error-messages="amountErrors"
/>
</form>
    </va-modal>
    <div class="row mt-5">            
                <va-button type="submit" @click="onsubmit"  v-if="showsubmit">
                  {{ $t('forms.controls.submit') }}
                </va-button> 
                

            </div>
      	 </va-card>
      </div>
    </div>
  
  </div>
</template>
<script src="https://unpkg.com/vue@2.5.13/dist/vue.js"></script>
<script>
import axios from 'axios'
import * as spinners from 'epic-spinners'

export default {
  components: {
    ...spinners      
  },
  name: 'loan',
  data () {
    return {
      userData: JSON.parse(localStorage.getItem('LoggedUser')),
      accdetails: JSON.parse(localStorage.getItem('UserMianFosa')),
      token: JSON.parse(localStorage.getItem('Token')),   
      loan_no : this.$route.params.loan_no,
      loading: false,
      term: null,
      processingError: false,
      mobilenumberErrors: false,
      errorMessages: false,
      amountErrors: false,
      payment_method : '',
      finalPost : '',
      loan_number: '',
      showaddG : true,
      showedit: true,
      showsubmit: true,
      details: [
        {
          loan_number: '',
        }],
      formdata:{
        phone_no:'',
        loanT:'',
        amount:'',
        LoanapplicationNo:'',
        appliedamount:'',
        AmountGuarantee:'',
        grossSalary:'',
        phonenumber:'',
        Delete:'',
        mobilenumber:'',
        user: '',
        name:'',
       
        ApprovalStatus:'',
        
      },
      mobilenumber:'',
      montlyrepayment:'',
      loanT:'',
      amount:'',
      Delete:'',
      mode: 0,
      ApprovalStatus:'',
      showConfirmModal : false, 
      showsubmit: true,
      showaddG : true,
      showedit : true,
      showdelete:false,
      showdel:false,
      showName: false,
      name:'',
      phonenumber:'',
        LoanapplicationNo:'',
        appliedamount:'',
        AmountGuarantee:'',
        repaymentperiod:'',
      config: {
        size: 80,
        duration: 1500,
      },
      spinnersColor: this.$themes.secondary,
      currentDuration: 1500,
      sliderDuration: {
        min: 1000,
        max: 2000,
      }     
    }
  },
  computed: {
    speed () {
      return this.sliderDuration.min + this.sliderDuration.max - this.currentDuration
    },

fields () {
      return [{
        name: '__slot:icon',
        width: '30px',
        dataClass: 'text-center',
      }, {
        name: '__slot:guarantor_full_name',
        title: this.$t('Guarantor Name'),
        width: '30%',
        sortField: 'amount',
      }, 
      {
        name: '__slot:phone_number',
        title: this.$t('Phone Number'),
        width: '20%',
        sortField: 'amount',
      },
      {
        name: '__slot:guaranteed_amount',
        title: this.$t('Amount Guaranteed'),
        width: '20%',
        sortField: 'amount',
      },
      {
        name: '__slot:guarantor_status',
        title: this.$t('Approval Status'),
        width: '20%',
        sortField: 'amount',
      },
      {
        name: '__slot:details',
        title: this.$t(''),
        width: '20%',
        sortField: 'details',
      }]
    },
    filteredData () {
      if (!this.term || this.term.length < 1) {
        return this.details
      }
      console.log(this.term);
      return this.details.filter(item => {
        return item.description.toLowerCase().startsWith(this.term.toLowerCase()) || item.amount.toLowerCase().startsWith(this.term.toLowerCase())
      })
    },
    formReady () {

     },      
  },
  methods : {

    GetProduct(id) {      
      return this.loans.filter(item => item.loanType.toLowerCase() === this.id.toLowerCase());      
    },
    Getloand(id) {      
      return this.det.filter(item => item.loan_number.toLowerCase() === this.id.toLowerCase());      
    },
    onsubmit (e) {
      e.preventDefault();
      this.formdata.AmountGuarantee = parseFloat(this.formdata.AmountGuarantee).toFixed(2);

      let config = {
        headers: {
          Authorization: this.userData.user_id+' '+this.token
        }
        }

        const formdata= {
       user:this.userData.user_id,
       phonenumber: this.userData.mobile_number,
       Loanproduct: this.formdata.loanT,

     };

     let qualifybyguarantor;

      // axios.post(`${self.$apiUrl}getloanproductdetails`, this.formdata.loanT, config)
      axios.post(`${this.$apiUrl}getloanproductdetails`, formdata, config) 
      .then(function (res) {
        // console.log(res.data.qualify_by_guarantors)

        qualifybyguarantor = res.data.qualify_by_guarantors;
      })

      console.log('qualifybyguarantor='+qualifybyguarantor)
      console.log('guaranteed amount='+this.formdata.AmountGuarantee)
      console.log('Loan Amount='+this.formdata.appliedamount)
      console.log('Loan test='+this.formdata.loanT)
      if((this.formdata.AmountGuarantee < this.formdata.appliedamount) && (qualifybyguarantor =='1')){
                    
			          this.showToast(`Loan is not yet fully Guaranteed`, {
			            position: 'bottom-right',
			            icon: "fa-check",
			            duration: 2500,
			          })
                
      }else{
             
      console.log(this.formdata.appliedamount);
           const form = {
       user:this.userData.user_id,
       phonenumber: this.userData.mobile_number,
       LoanapplicationNo: this.loan_no,

     };
    

     		this.loading = true
				var self = this

				let config = {
					headers: {
						Authorization: this.userData.user_id+' '+this.token
					}
					}

				axios.post(`${this.$apiUrl}SubmitLoan`, form, config) 
				.then(function (res) {
					self.loading = false					
					const resp = res.data;
					
					if(resp == true){              
			          self.showToast(`Loan Successfuly Submited`, {
			            position: 'bottom-right',
			            icon: "fa-check",
			            duration: 2500,
			          })
                setTimeout( () => window.location.reload(), 2500);
			        } else {
			          self.processingError = true
			        }                 
				})
				.catch(function (error) {
				  console.log(error)
				})
  
      } 
       
      
    },
    guarantors(){
      this.showConfirmModal = true;
    },
    EditLoanspage(loan_no){
      console.log(this.loan_no);
      this.$router.push({name: 'loan-EditLoan', params: { LoanapplicationNo:this.loan_no}});
    },
    GetAppliedLoanDetails () {
      this.loadSelect = true
      this.loading=true
      const self = this
      const form = {
  user:this.userData.user_id,
  LoanapplicationNo:this.loan_no,
      }
      let config = {
        headers: {
          Authorization: this.userData.user_id+' '+this.token
        }
      }

      axios.post(`${self.$apiUrl}ListLoanGuarantors`, form, config)
      .then(function (res) {
        
          self.loadSelect = false
          self.loading = false
          res = res.data
          self.details = res.slice()

      })
      .catch(function (error) {
          console.log(error)
      })
    },
    CheckIfGuarantorshipApp() {
      this.loadSelect = true
      const self = this
      const form = {
  user:this.userData.user_id,
  LoanapplicationNo:this.loan_no,
  phonenumber: this.userData.mobile_number,
      }
      let config = {
        headers: {
          Authorization: this.userData.user_id+' '+this.token
        }
      }

      axios.post(`${self.$apiUrl}CheckGuarantorshipApproval`, form, config)
      .then(function (res) {
        const resp = res.data;
        if(resp == true){              

         self.showedit=true
        
			} else if(resp == false) {

                self.showedit=false
			        } 
        else{
                self.showedit=true
      }
      })
      .catch(function (error) {
          console.log(error)
      })
    },
    CheckIfSubmitted () {
      this.loadSelect = true
      const self = this
      const form = {
  user:this.userData.user_id,
  LoanapplicationNo:this.loan_no,
  phonenumber: this.userData.mobile_number,
      }
      let config = {
        headers: {
          Authorization: this.userData.user_id+' '+this.token
        }
      }

      axios.post(`${self.$apiUrl}CheckIfSubmitted`, form, config)
      .then(function (res) {
        const resp = res.data;
        if(resp == true){              
			         
         self.showsubmit= false
         self.showaddG = false
         self.showedit=false
        
			} else {
                self.showsubmit=true;
                self.showaddG = true;
                self.showedit=true
			        } 
      })
      .catch(function (error) {
          console.log(error)
      })
    },
    Deleteguaranter(LoanapplicationNo, phonenumber,id_number) {
      console.log(LoanapplicationNo);
      console.log(phonenumber);
      console.log(id_number);
      const form = {
       user:this.userData.user_id,
       phonenumber: phonenumber,
       LoanapplicationNo:LoanapplicationNo,
       id_number: id_number,

     };
     console.log(this.formdata.amount)

     		this.loading = true
				var self = this

				let config = {
					headers: {
						Authorization: this.userData.user_id+' '+this.token
					}
					}

				axios.post(`${this.$apiUrl}DeleteGuarantor`, form, config) 
				.then(function (res) {
					self.loading = false					
					const resp = res.data;
					
					if(resp == true){              
			          self.showToast(`Guarantor Deleted succefully`, {
			            position: 'bottom-right',
			            icon: "fa-check",
			            duration: 2500,
			          })
                setTimeout( () => window.location.reload(), 2500);
			        } else {
			          self.processingError = true
			        }                 
				})
				.catch(function (error) {
				  console.log(error)
				})
  
      //this.$router.push({name: 'loan-GuarantorshipRequests', params: { loan_no:LoanapplicationNo }});
},
loaddetais(value){
      this.GetGuarantorDetails()
    this.showName = true
         this.formdata.name =  value.full_name 
           console.log(this.formdata.name)
  },
 
   GetGuarantorDetails() {
      
      const self = this

    	let config = {
					headers: {
						Authorization: this.userData.user_id+' '+this.token
					}
					}
      const form = {
        user:this.userData.user_id,
        phonenumber: this.formdata.mobilenumber,
      };
      axios.post(`${self.$apiUrl}GetMemberDetails`, form, config)
        .then(function (res) {
          self.loadSelect = false
          self.loading = false

          res = res.data
          
          console.log(res)
          self.formdata.name = res.full_name
          console.log(self.formdata.name)
        })

        .catch(function (error) {
          console.log(error)
        })
       
    },
FinalPost(){
  console.log(this.loan_no)
      this.processingError = false;
      this.mobilenumberErrors = this.formdata.mobilenumber ? [] : ['Guarantor Phone Number is required']
     this.amountErrors=this.formdata.amount ? [] : ['Amount is requested']

     if(this.formdata.name==null){
      this.showToast(`Guarantor not found`, {
			            position: 'bottom-right',
			            icon: "fa-check",
			            duration: 2500,
			          })
     }
     else{
    const form = {
       user:this.userData.user_id,
       phonenumber: this.formdata.mobilenumber,
       LoanapplicationNo:this.loan_no,
       amount:this.formdata.amount
     };
    
     console.log(this.formdata.amount)

     		this.loading = true
				var self = this

				let config = {
					headers: {
						Authorization: this.userData.user_id+' '+this.token
					}
					}
          axios.post(`${this.$apiUrl}CheckGuarantor`, form, config) 
				.then(function (res) {
					self.loading = false					
					const resp = res.data;
					
					if(resp == false){ 
            self.Requestguarant()             
			          
			        } else if(resp == true){
                self.showToast(`You have already Requested guarantorship from this person`, {
			            position: 'bottom-right',
			            icon: "fa-check",
			            duration: 25000,
			          })
                setTimeout( () => window.location.reload(), 2500);
  
			        }  else {
			          self.processingError = true
			        }               
				})
				.catch(function (error) {
				  console.log(error)
				})
      }		
},
Requestguarant () {
  const form = {
       user:this.userData.user_id,
       phonenumber: this.formdata.mobilenumber,
       LoanapplicationNo:this.loan_no,
       amount:this.formdata.amount,
       loanamount:this.formdata.appliedamount
     };
     console.log(this.formdata.amount)

     		this.loading = true
				var self = this

				let config = {
					headers: {
						Authorization: this.userData.user_id+' '+this.token
					}
					}

      axios.post(`${this.$apiUrl}RequestGuarantorship`, form, config) 
				.then(function (res) {
					self.loading = false					
					const resp = res.data;
					
					if(resp == true){              
			          self.showToast(`Guarantorship Request sent succefully`, {
			            position: 'bottom-right',
			            icon: "fa-check",
			            duration: 2500,
			          })
                setTimeout( () => window.location.reload(), 2500);
			        } else {
			          self.processingError = true
			        }                 
				})
				.catch(function (error) {
				  console.log(error)
				})
    },

GetLoanDetails () {
      this.loadSelect = true
      const self = this
      const form = {
        LoanapplicationNo:this.loan_no,
  user:this.userData.user_id

      }

      let config = {
        headers: {
          Authorization: this.userData.user_id+' '+this.token
        }
      }

      axios.post(`${self.$apiUrl}IndividualLoanDetails`, form, config)
      .then(function (res) {

          self.loadSelect = false
          self.loading = false
          res = res.data
          self.details = res;
          self.formdata.AmountGuarantee= res.amount_guaranteed;
          self.formdata.appliedamount = res.applied_amount;
          self.formdata.loanT = res.loan_product;
          console.log(res.applied_amount)
      })
      .catch(function (error) {
          console.log(error)
      })
    },
 
  },
  created () { 
    this.GetAppliedLoanDetails();
    
    this.GetLoanDetails();
   this.CheckIfSubmitted();
  //this.CheckIfGuarantorshipApp();
  }
}
</script>